import Green1 from "../assets/ProductImages/green1.jpeg";
import Green2 from "../assets/ProductImages/green2.jpeg";
import Green5 from "../assets/ProductImages/green6.jpeg";
import Green6 from "../assets/ProductImages/green5.jpeg";
import Black1 from "../assets/ProductImages/black1.jpeg";
import Black2 from "../assets/ProductImages/black2.jpeg";
import Black3 from "../assets/ProductImages/black8.jpeg";
import Black4   from "../assets/ProductImages/tee5.jpg";
import Black5 from "../assets/ProductImages/black5.jpeg";
import Black6 from "../assets/ProductImages/black4.jpeg";
import Black7 from "../assets/ProductImages/tee4.jpg";
import Bracelet from "../assets/ProductImages/acc1.jpg";
import Bracelet2 from "../assets/ProductImages/acc2.jpg";
import Necklace from "../assets/ProductImages/acc4.jpg";
import Necklace2 from "../assets/ProductImages/acc5.jpg";
import Jeans2 from "../assets/ProductImages/jeans.jpg";
import Shirt2 from "../assets/ProductImages/shirt16.jpg";
import Shirt3 from "../assets/ProductImages/shirt15.jpg";
import Shirt4 from "../assets/ProductImages/shirt17.jpg";
import Black8 from "../assets/ProductImages/black6.jpeg";
import Black9 from "../assets/ProductImages/black7.jpeg";
import Jeans10 from "../assets/ProductImages/jeans10.jpg";
import Jeans11 from "../assets/ProductImages/jeans11.jpg";



const latestDrops = [
  {
    id:1,
    title: "Bambiha: The Degenerate",
    category: "t-Shirts",
    price: 850,
    img: [Black1, Black2, Black3],
  },
  {
    id:2,
    title: "Oversized Shirt: Green",
    category: "t-Shirts",
    price: 1299,
    img: [Green1,Green2,Green5,Green6],
  },
  {
    id:3,
    title: "Varsity T-Shirt: Sangria",
    category: "t-Shirts",
    price: 1299,
    img: [Black8,Black9],
  },
  {
    id:4,
    title: "Chaos: The Anarchist",
    category: "t-Shirts",
    price: 1599,
    img: [Black4,Black7],
  },

  {
    id:5,
    title: "Bracelet: Men Modern Design",
    category: "accessories",
    price: 349,
    img: [Bracelet,Bracelet2],
  },
        {
            id:6,
            title: "Men: Modern Neck chain",
            category: "accessories",
            price: 259,
            img: [Necklace,Necklace2],
        },

          {
            id:7,
    title: "Men: Straight Denim Jeans",
    category: "bottoms",
    price: 1199,
    img: [Jeans2, Jeans10, Jeans11],
  },

            {
                id:8,
    title: "Men: Blue Checked Shirt",
    category: "shirts",
    price: 899,
    img: [Shirt2, Shirt3, Shirt4],
  },
];


export default latestDrops